import { Helpers } from '../helpers';
import jsonpAdapter from '../axios-jsonp';
/**
 * TODO: figure out how to derive some of these values maybe from HPServices
 */
const DEFAULT_CTO_PICK_JSON = {
    include: [
        { clazz: 'Messages' },
        {
            clazz: 'Property',
            name: '_isViewable||_quantity||_rulePick||UI: PRE PICK GUIDING TEXT||UI: POST PICK GUIDING TEXT||UI: SUPPRESS NONE SELECTION||UI: REQUIRED||_dsku||UI: DISPLAY NAME||UI: PRODUCT NAME||UI: LEAD TIME',
        },
    ],
    country: 'US',
    currency: 'USD',
    language: 'en',
    organizationCode: 'US_Store',
    addPick: [],
    removePick: [],
};

class CTO {
    constructor(apiConfig, http) {
        this.apiConfig = apiConfig;
        this.http = http;
    }

    /**
     *
     * @param {*} leadDays
     * @param {*} currentDate
     * @param {*} webSvcSessionID
     * @param {*} apiTemplateJSONString
     * @param {*} calendarId
     * @param {*} callback
     * @returns Returns the ship date based on the lead time
     */
    getShipDate(
        leadDays = 14,
        currentDate,
        webSvcSessionID = '',
        apiTemplateJSONString = '',
        calendarId = 'CTO-CALENDAR-NB',
        callback = '_ship_id'
    ) {
        const params = {
            storeId: this.apiConfig.siteInfo.storeId,
            webSvcSessionID,
            apiTemplateJSONString,
            calendarId,
            leadDays,
            currentDate: currentDate || Helpers.date.etrDateFormat(new Date().toUTCString()),
            callback,
        };
        return this.http.get(`getshipdate`, { params, adapter: jsonpAdapter }).then(resp => {
            const { data, status } = resp;
            //attempt to parse response
            if (status === 200 && data && data !== '') {
                return data;
            } else {
                return Promise.reject({ status });
            }
        });
    }

    processConfigurationPicks(
        jsonData,
        webSvcSessionID = '',
        apiTemplateJSONString = '',
        tokenID = '',
        callback = '_jqjsp'
    ) {
        const params = {
            inJSONString: { ...DEFAULT_CTO_PICK_JSON, ...jsonData },
            webSvcSessionID,
            apiTemplateJSONString,
            tokenID,
            callback,
        };
        return this.http.get(`processconfigurationpicksjson`, { params, adapter: jsonpAdapter }).then(resp => {
            const { data, status } = resp;
            //attempt to parse response
            if (status === 200 && data && data !== '') {
                return data;
            } else {
                return Promise.reject({ status });
            }
        });
    }
}

export default CTO;
